<template>
    <div class="section-digital-allies" id="sobre-casamarket">
	  <v-flex text-xs-center class="content-img mb-4">
		  <img src="/static/images-new/logos/logo-casamarket.svg" alt="">
	  </v-flex>
      <v-flex text-xs-center class="w-medium newarning--text title-digital">Nacemos con el propósito de ser <span class="w-bold primary--text">tus aliados digitales</span> </v-flex>
		<v-flex class="mt-4 newwarning--text subtitle-digital" text-xs-center>Atendemos todo tipo de empresas, brindando soluciones de venta online y gestión</v-flex>
		<div class="content-allies">
			<div class="item-allies" v-for="(allie, index) in allies" :key="index">
				<img :src="allie.image" alt="">
				<div class="primary--text fs-14 allie-name">{{ allie.name }}</div>
			</div>
		</div>
	</div>
</template>

<script>
function data() {
	return {
		allies: [
			{
				id: 1,
				name: 'Ayudamos a incrementar tus ventas y fidelizar a tus clientes',
				image: '/static/images-new/icons/icon-allie-1.svg',
			},
			{
				id: 2,
				name: 'Nuestros productos son muy sencillos de usar para ti y tus clientes',
				image: '/static/images-new/icons/icon-allie-2.svg',
			},
			{
				id: 3,
				name: 'Hacemos más eficiente la gestión de tu Negocio',
				image: '/static/images-new/icons/channel-1.svg',
			},
		],
	};
}

export default {
	name: 'section-digital-allies',
	data,
};
</script>

<style lang="scss" scoped>
.section-digital-allies {
	background-color: #f5fbfb;
	padding: 90px 0; 

	@media (max-width: 936px) {
		padding: 67px 38px 45px 38px;
	}
}

.item-allies {
	border-radius: 9px;
  	box-shadow: 0 2px 15px 0 rgba(0, 0, 0, 0.06);
	background-color: #ffffff;
	margin-left: 61px;
	max-width: 184px;
	padding: 25px 16px 28px 16px;
	text-align: center;

	@media (max-width: 936px) {
		display: flex;
		align-items: center;
		margin: 0 0 13px 0;
		max-width: 100%;
	}

	&:first-child {
		margin-left: 0;
	}
}

.content-allies {
	display: flex;
	justify-content: center;
	margin-top: 79px;

	@media (max-width: 936px) {
		margin-top: 30px;
		align-items: center;
		flex-direction: column;
	}
}

.title-digital {
	color: #494949;
	font-size: 18px;

	@media (min-width: 936px) {
		font-size: 27px;
	}
}

.allie-name {
	margin: 0 0 0 22px;
	text-align: left;

	@media (min-width: 936px) {
		margin: 30px 0 0 0;
		text-align: center;
	}
}

.subtitle-digital {
	font-size: 14px;

	@media (min-width: 936px) {
		font-size: 18px;
	}
}
</style>


// WEBPACK FOOTER //
// src/components/home-new/section-digital-allies.vue